import request from '@/axios'
import xbb from '@xbb/xbb-utils'
import utils from '../../utils'

const { WEBPACK_NEW_GATEWAY_URL, WEBPACK_NEW_GATEWAY_URL_INDEPENDENT } = process.env
import sha256 from 'sha256'

function CharacterFilter(str) {
  let newStr = ''
  for (let i = 0; i < str.length; i++) {
    const us = str.charCodeAt(i)
    if (!(us < 0x20 || us === 0x7f || us === 0x2028 || us === 0x2029)) {
      newStr += str.charAt(i)
    }
  }
  return newStr
}

function createSign(params) {
  let bodyString = JSON.stringify(Object.assign(params))
  if (bodyString.length > 100) {
    bodyString = CharacterFilter(bodyString)
  }
  return sha256(bodyString.trim() + (utils.xbbLocalStorageGet('xbbAccessToken') || '1'))
}

function getQoderGatewayUrl() {
  const platform = utils.getPlatform(utils.xbbLocalStorageGet('corpid'))
  return xbb.isDevEnv() || platform === 'dd'
    ? WEBPACK_NEW_GATEWAY_URL
    : WEBPACK_NEW_GATEWAY_URL_INDEPENDENT
}

function getSSERequestData(data = {}) {
  return {
    corpid: utils.xbbLocalStorageGet('corpid'),
    userId: utils.xbbLocalStorageGet('userId'),
    platform: utils.isMobile() ? 'dingtalk' : 'web',
    ...data
  }
}

async function getSSEBody(response, url) {
  const contentType = response.headers.get('content-type') || ''
  console.log('[AI SSE response content-type]', contentType)
  if (response.ok && contentType.includes('text/event-stream') && response.body) {
    return response.body
  }

  const responseText = await response.text()
  let responseData = null
  try {
    responseData = responseText ? JSON.parse(responseText) : null
  } catch (error) {
    console.error('[AI SSE response parse failed]', error)
  }
  console.error('[AI SSE request failed]', {
    url,
    status: response.status,
    statusText: response.statusText,
    data: responseData || responseText
  })
  throw {
    data: responseData || responseText
  }
}

// 创建会话
export function createSession(data) {
  return request({
    url: '/api/qca/sessions',
    data
  })
}

// 取消/终止当前正在执行的会话
export function cancelSession(data) {
  return request({
    url: '/api/qca/sessions/cancel',
    data
  })
}

// 发送会话事件
export function sendSessionEvent(data) {
  return request({
    url: '/api/qca/sessions/events/send',
    data
  })
}

// 获取会话列表
export function getSessionList(data) {
  return request({
    url: '/api/qca/sessions/list',
    data
  })
}

// 获取会话详情
export function getSession(data) {
  return request({
    url: '/api/qca/sessions/get',
    data
  })
}

// 更新会话状态
export function updateSession(data) {
  return request({
    url: '/api/qca/sessions/status/update',
    data
  })
}

// 置顶 / 取消置顶会话
export function updateSessionTop(data) {
  return request({ url: '/api/qca/sessions/top/update', data })
}

// 重命名会话
export function renameSession(data) {
  return request({ url: '/api/qca/sessions/update', data })
}

// 删除会话
export function deleteSession(data) {
  return request({ url: '/api/qca/sessions/delete', data })
}

/**
 * 订阅指定会话的 SSE 事件流。
 * @param {Object} data 请求参数
 * @param {{ signal?: AbortSignal }} options signal 用于主动断开该流（切会话 / 离开页面）
 */
export async function getSessionEventStream(data, options = {}) {
  data = getSSERequestData(data)
  const gatewayUrl = getQoderGatewayUrl()
  const url = `${gatewayUrl}/api/qca/sessions/stream`
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/event-stream',
      'Cache-Control': 'no-cache',
      sign: createSign(data)
    },
    body: JSON.stringify(data),
    signal: options.signal,
    redirect: 'follow'
  })
  return getSSEBody(res, url)
}

// 获取会话文件详情
export function getSessionFile(data) {
  return request({
    url: '/api/qca/sessions/files/get',
    data
  })
}

// 获取会话历史事件列表
export function getSessionEventList(data) {
  return request({
    url: '/api/qca/sessions/events/list',
    data
  })
}

// 检查用户身份
export function checkIdentity(data) {
  return request({
    url: '/api/qca/provisioning/checkIdentity',
    data
  })
}

// 获取会话文件内容
export function getFileJson(data) {
  return request({
    url: '/api/qca/sessions/files/content/get',
    data
  })
}

// 分享html
export function shareFile(data) {
  return request({
    url: '/api/qca/sessions/files/share',
    data
  })
}
